import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-dropdown-select';
import cx from 'classnames';

import SxIcon from './sxIcon';
import BetaTag from './betaTag';
import AutoEllipsisTooltip from './autoEllipsisTooltip';

import { striptagsAndUnescapeText } from '../utils/helpers';

import styles from './selectDropdown.module.scss';

class SelectDropdown extends Component {
  constructor(props) {
    super(props);
    this.dropdownRendererMulti = this.dropdownRendererMulti.bind(this);
    this.dropdownRenderer = this.dropdownRenderer.bind(this);
    this.renderOptionsMulti = this.renderOptionsMulti.bind(this);
    this.renderOptionMulti = this.renderOptionMulti.bind(this);
    this.contentRenderer = this.contentRenderer.bind(this);
    this.onSelectOption = this.onSelectOption.bind(this);
  }
  // eslint-disable-next-line max-params
  onRemoveOption(option, values = [], { removeItem }, event) {
    const pos = values.indexOf(option.value);
    values.splice(pos, 1);
    removeItem(event, option);
    this.props.onChange(event, { value: values });
  }
  onSelectSingle(option, { addItem }, event) {
    addItem(option);
    this.props.onChange(event, { value: option.value });
  }
  // eslint-disable-next-line max-params
  onSelectOption(option, _, { addItem }, event) {
    const { value = [] } = this.props;
    addItem(option);
    this.props.onChange(event, { value: [...value, option.value] });
  }
  renderValue(option, values = [], methods) {
    if (!option) {
      return null;
    }
    const { selectedOptionClassName } = this.props;
    const { key, text, value } = option;
    return (
      <div
        key={key ? key : value}
        className={cx(styles.selectedOption, selectedOptionClassName)}
        onClick={this.onRemoveOption.bind(this, option, [...values], methods)}
      >
        <AutoEllipsisTooltip text={this.getTextToShow(text)} fullWidth />
        <div className={styles.removeButton}>
          <SxIcon name="sx-icon-x" />
        </div>
      </div>
    );
  }
  renderSingleValue(option) {
    if (!option && option !== 0) {
      return null;
    }

    const { text, isBeta } = option;
    return (
      <div className={styles.selectedSingleOption}>
        <AutoEllipsisTooltip text={this.getTextToShow(text, isBeta)} fullWidth />
        <div className={styles.removeButton}></div>
      </div>
    );
  }
  contentRenderer({ props, methods }) {
    const { value: values = [], options, multiple = false } = this.props;
    if (values !== 0 && (!values || values.length === 0)) {
      return <div className={styles.placeholder}>{props.placeholder}</div>;
    }
    if (multiple && Array.isArray(values)) {
      return values.map((value) => {
        const option = options.find((option) => option.value === value);
        return this.renderValue(option, values, methods);
      });
    }
    const value = values;
    const option = options.find((option) => option.value === value);
    return this.renderSingleValue(option);
  }
  renderOptionMulti(option, state, methods) {
    const { key, text, value } = option;
    return (
      <div
        key={key ? key : value}
        className={styles.dropdownOption}
        onClick={this.onSelectOption.bind(this, option, state, methods)}
      >
        <AutoEllipsisTooltip text={this.getTextToShow(text)} fullWidth />
      </div>
    );
  }
  renderOptionsMulti(options, state, methods) {
    const { value } = this.props;
    return options
      .filter((option) => !value.includes(option.value))
      .map((option) => {
        return this.renderOptionMulti(option, state, methods);
      });
  }
  dropdownRendererMulti({ props, state, methods }) {
    const { options } = props;
    return <div className={styles.dropdownContainer}>{this.renderOptionsMulti(options, state, methods)}</div>;
  }
  renderBetaTag(isBeta) {
    if (!isBeta) {
      return null;
    }
    return <BetaTag />;
  }
  getTextToShow(text, isBeta) {
    const { showHtml = false } = this.props;
    let textToShow = text;
    if (!showHtml) {
      return (
        <span>
          {striptagsAndUnescapeText(text)} {this.renderBetaTag(isBeta)}
        </span>
      );
    }
    return <span dangerouslySetInnerHTML={{ __html: textToShow }} />;
  }
  renderOptionSingle(option, methods) {
    const { key, text, value, isBeta } = option;

    return (
      <div
        key={key ? key : value}
        className={styles.dropdownOption}
        onClick={this.onSelectSingle.bind(this, option, methods)}
      >
        <AutoEllipsisTooltip text={this.getTextToShow(text, isBeta)} maxTextLines={1} placement="bottom" fullWidth />
      </div>
    );
  }
  renderOptionsSingle(options, methods) {
    return options.map((option) => {
      return this.renderOptionSingle(option, methods);
    });
  }
  dropdownRendererSingle({ props, methods }) {
    const { options } = props;
    return <div className={styles.dropdownContainer}>{this.renderOptionsSingle(options, methods)}</div>;
  }
  dropdownRenderer({ props, state, methods }) {
    const { multi } = props;
    if (multi) {
      return this.dropdownRendererMulti({ props, state, methods });
    }
    return this.dropdownRendererSingle({ props, state, methods });
  }
  render() {
    const {
      placeholder = '',
      options = [],
      multiple = false,
      className,
      disabled,
      error,
      portal = false,
      fluid = false,
      compact = false,
      dropdownPosition = 'auto',
    } = this.props;
    const fullClassName = cx(styles.dropdown, className, {
      [styles.fullWidth]: fluid,
      [styles.compactWidth]: compact,
    });
    return (
      <div className={fullClassName}>
        <Select
          portal={portal}
          className={cx({ error: !!error })}
          options={options}
          contentRenderer={this.contentRenderer}
          dropdownRenderer={this.dropdownRenderer}
          multi={multiple}
          placeholder={placeholder}
          dropdownPosition={dropdownPosition}
          disabled={disabled}
        />
      </div>
    );
  }
}

SelectDropdown.propTypes = {
  placeholder: PropTypes.string,
  selectedOptionClassName: PropTypes.string,
  className: PropTypes.string,
};

SelectDropdown.defaultProps = {
  selectedOptionClassName: '',
};

export default SelectDropdown;
